import "./nav.css";
import { AiOutlineHome } from "react-icons/ai";
import { AiOutlineUser } from "react-icons/ai";
import { TiGroupOutline } from "react-icons/ti";
import { BiMessageRoundedDots } from "react-icons/bi";
import { BsArrowDownCircle } from "react-icons/bs";
import { BsArrowUpCircle } from "react-icons/bs";
import { useState } from "react";

function Navbar() {
  const [up, setUp] = useState(false);

  return (
    <div className="navigation">
      <a href="#home">
        <AiOutlineHome className="icon active-nav" />
      </a>
      <a href="#about">
        <AiOutlineUser className="icon" />
      </a>
      <a href="#members">
        <TiGroupOutline className="icon" />
      </a>
      <a href="#contact">
        <BiMessageRoundedDots className="icon" />
      </a>
      {
        !up ? <div> <a onClick={() => setUp(true)} href="#footer">
        <BsArrowDownCircle className="icon" />
      </a></div> : <a onClick={() => setUp(false)} href="#home">
          <BsArrowUpCircle className="icon" />
        </a>
      }


    </div>
  );
}

export default Navbar;
